import React from 'react'
//import {Button} from '@material-ui/core'

const Dashboard = () => {
    // const onClickMyaccount = () => {
    //     const no = window.location.href.indexOf('dashboard')
    //     const URL = window.location.href.substring(0, no)
    //     const FullURL = `${URL}myaccount`
    //     const hypernindex = FullURL.indexOf('-')
    //     const figindex = FullURL.indexOf('.figmd')
    //     console.log('Full URL::', FullURL)
    //     console.log('hypenindex URL::', hypernindex)
    //     console.log('fig URL::', figindex)
    // }
    return (
        <div>
            <div style={{'font-size': '50px', marginTop: '20%', marginLeft: '35%'}}>
                Welcome to Pegasus
            </div>
        </div>
    )
}

export default Dashboard
